<template>
    <div id="publication-dashboard">
      <div class="row">
        <div class="column">
          <div class="ui large header">
            {{ $t('Publication name') }}: {{ publicationName }}
            <span>({{ publicationCode.toUpperCase() }})</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <sui-breadcrumb>
            <sui-breadcrumb-section>
              <router-link :to="{ name: 'Publications' }">{{ $t('Publications') }}</router-link>
            </sui-breadcrumb-section>
            <sui-breadcrumb-divider icon="right chevron" />
            <sui-breadcrumb-section active>{{ $t('Dashboard') }}</sui-breadcrumb-section>
          </sui-breadcrumb>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <div class="ui">
            <sui-segment>
              <Publisher :publisher-data="publisherData" :data-requested="dataRequested"></Publisher>
            </sui-segment>
            <sui-segment>
              <div class="ui stackable grid test">
                <div class="sixteen wide mobile eight wide tablet five wide computer four wide large screen column">
                  <Schedules :schedules-data="schedules" :data-requested="dataRequested"></Schedules>
                </div>
                <div class="sixteen wide mobile eight wide tablet eleven wide computer twelve wide large screen column">
                  <Issues :issues-data="issues" :data-requested="dataRequested"></Issues>
                </div>
              </div>
            </sui-segment>
            <sui-segment>
              <Invoices :invoices-data="invoices" :data-requested="dataRequested" ></Invoices>
            </sui-segment>
            <sui-segment>
              <Configuration :publication-config="configuration" :data-requested="dataRequested"></Configuration>
            </sui-segment>
          </div>
        </div>
      </div>
      <br>
    </div>
</template>

<script>

import Configuration from './publication-dashboard/Configuration';
import Invoices from './publication-dashboard/Invoices';
import Issues from './publication-dashboard/Issues';
import Publisher from './publication-dashboard/Publisher';
import Schedules from './publication-dashboard/Schedules';

export default {
  components: {
    Configuration,
    Invoices,
    Issues,
    Publisher,
    Schedules
  },
  name: 'publication-dashboard',
  data() {
    return {
      configuration: {},
      invoices: {},
      issues: {},
      publicationCode: '',
      publicationName: '',
      publisherData: {},
      schedules: {},
      dataRequested: false
    };
  },
  created() {
    this.fetchPublicationDashboard();
  },
  methods: {
    fetchPublicationDashboard() {
      let schema = this.$store.getters.coreapiSchema;
      let client = this.$store.getters.coreapiClient;
      let action = ['publication_dashboard', 'read'];
      let params = {
        id: this.$route.params.id,
      };
      client.action(schema, action, params).then((result) => {
        this.dataRequested = true;
        this.configuration = result.configuration;
        this.invoices = result.invoices;
        this.issues = result.issues;
        this.publicationCode = result.code;
        this.publicationName = result.name;
        this.publisherData = result.publisher;
        this.schedules = result.schedules;
      });
    },
  }
};
</script>

<style scoped>
.ui.breadcrumb {
  padding: 1rem 0;
}
</style>
